// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"727":"1d17e60c765a6025","888":"a6a8578e3aa2bd67"}[chunkId] + ".css";
};